"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipesNavigationLink = void 0;
const preact_1 = require("preact");
function RecipesNavigation({ currentPage, setCurrentPage, maxPage, scrollToTop }) {
    const previous = () => {
        setCurrentPage(currentPage - 1);
        scrollToTop();
    };
    const next = () => {
        setCurrentPage(currentPage + 1);
        scrollToTop();
    };
    return ((0, preact_1.h)("div", { className: 'wrapper  pagination  recipes-page__pagination  page__padding' },
        (0, preact_1.h)("button", { type: 'button', onClick: previous, disabled: currentPage === 1, className: 'button  button--dark  button--small  font-veneer  tracking-wide' }, "Previous page"),
        (0, preact_1.h)("button", { type: 'button', onClick: next, disabled: currentPage === maxPage, className: 'button  button--dark  button--small  font-veneer  tracking-wide' }, "Next page")));
}
exports.default = RecipesNavigation;
function RecipesNavigationLink(_a) {
    var { page } = _a, props = __rest(_a, ["page"]);
}
exports.RecipesNavigationLink = RecipesNavigationLink;
